import React from "react";
import clsx from "clsx";

interface LogoProps {
    className?: string;
    size?: "sm" | "md" | "lg";
    showText?: boolean;
}

export default function Logo({ className, size = "md", showText = true }: LogoProps) {
    const sizeClasses = {
        sm: "w-8 h-8",
        md: "w-12 h-12",
        lg: "w-20 h-20",
    };

    const textSizeClasses = {
        sm: "text-xs",
        md: "text-lg",
        lg: "text-2xl",
    };

    return (
        <div className={clsx("flex flex-col items-center justify-center gap-3", className)}>
            <div className={clsx("relative flex items-center justify-center", sizeClasses[size])}>
                <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full h-full drop-shadow-[0_0_10px_rgba(16,185,129,0.3)]"
                >
                    <defs>
                        <linearGradient id="logoGradient" x1="10" y1="90" x2="90" y2="10" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#10b981" />
                            <stop offset="1" stopColor="#34d399" />
                        </linearGradient>
                    </defs>

                    {/* Abstract L shape interwoven with Infinity loop */}
                    <path
                        d="M30 20 V80 H80"
                        stroke="url(#logoGradient)"
                        strokeWidth="12"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="opacity-90"
                    />
                    <circle cx="70" cy="30" r="10" fill="url(#logoGradient)" className="animate-pulse" />
                </svg>
            </div>
            {showText && (
                <div className="text-center">
                    <h1 className={clsx("font-bold tracking-[0.2em] uppercase text-white leading-tight", textSizeClasses[size])}>
                        LongevityOS
                    </h1>
                    {size === "lg" && (
                        <p className="text-sm text-text-muted mt-1">Your personal AI health & longevity coach</p>
                    )}
                </div>
            )}
        </div>
    );
}
